// Implemented according to the following tutorial:
// https://ews-tactical.atlassian.net/wiki/spaces/~314660989/pages/3351807765/How+to+open+FMO+Mobile+redirect+modal

const openFMOPopup = (url) => {
  const fmoModalIntentEvent = document.createEvent('CustomEvent');
  fmoModalIntentEvent.initCustomEvent(
    'FMO_REDIRECT_MODAL_INTENT', // Name must be this!
    true, // canBubbleArg, probably will always be true
    true, // cancelableArg, probably will always be true
    {
      targetUrl: url,
      // This callback is called when header will decide
      // to not open FMO mobile redirect popup. Can be in case link is not going to `/mobile`. But you do not need to care.
      ifNotOpening: () => {

      }
    }
  );

  document.dispatchEvent(fmoModalIntentEvent);
};

export default openFMOPopup;
